import httpClient from 'api/httpClient';
import { AuthBody, LoginRequest } from 'models/AuthBody';

function login(dataRoomId: string, userData?: LoginRequest) {
  return httpClient.post<AuthBody>(
    `data-rooms/${dataRoomId}/auth/login`,
    userData,
  );
}

function preLogin(dataRoomId: string) {
  return httpClient.post<{
    shouldAuthenticate: boolean;
  }>(`data-rooms/${dataRoomId}/auth/pre-login`);
}

export default {
  login,
  preLogin,
};
